<template>
  <div class="rollList">
    <div v-for="(it, idx) in list" :key="idx">
      <div :id="'menu' + idx"></div>
      <div :style="{ 'background-color': it.bg }" class="rollCon">
        <h4>
          {{ it.title }}
        </h4>
        <p v-if="it.p" v-html="it.p"></p>
        <ul>
          <li
            :style="{ 'background-image': 'url(' + it.icon + ')' }"
            v-for="(item, index) in it.list"
            :key="index"
            v-html="item"
          ></li>
        </ul>
        <img :src="it.img" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    list: {
      type: Array,
      default: [],
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
.rollList {
  .rollCon {
    padding: 50px 0;
  }
  h4 {
    margin-bottom: 30px;
    font-size: 30px;
    color: #055dd8;
    padding: 0 20px;
  }
  ul {
    padding: 0 20px;
  }
  li {
    margin-bottom: 45px;
    padding-left: 30px;
    background-repeat: no-repeat;
    background-position: left 10px;
    background-size: 19px 18px;
    line-height: 35px;
    color: #808080;
    font-size:24px;
    line-height: 45px;
    span {
      color: #808080;
      font-weight: bold;
    }
  }
  p {
    color: #2048cb;
    margin-bottom: 44px;
    text-align: left;
    padding: 0 20px;
    font-size: 24px;
  }

  img {
    display: block;
    margin: 30px auto;
    width: 663px;
    //  height:465px;
  }
}
</style>
